export function isMobile() {
  return /Android|webOS|iPad|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
}

export function isMacOs() {
  return /Mac OS/i.test(navigator.userAgent);
}